import {defineStore} from "pinia";

export const useStore = defineStore('ems', {
    persist: true,
    state: () => {
        return {
            // 登录状态
            isLogin: false,
            token: null,
            //  刷新token
            refreshToken: null,
            //  当前登录用户信息
            userInfo: null,
            //  面试信息列表
            interviewList: [],
            //  对话列表
            // 面试对话信息 - 改为对象格式，以面试id为key
            interviewConversation: {},
            //当前问题
            questionNow: null,
            // 面试答题内容缓存
            interviewAnswerCache: {},
            // 面试答题历史记录缓存
            interviewAnswerRecord: {},
            websocketTime: {}, // WebSocket累计计时缓存
            websocketIp: null, // WebSocket IP地址缓存
        }
    },
    actions: {
        // 根据面试id获取对话列表
        getConversationByInterviewId(interviewId) {
            return this.interviewConversation[interviewId] || [];
        },
        // 根据面试id设置对话列表
        setConversationByInterviewId(interviewId, conversationList) {
            this.interviewConversation[interviewId] = conversationList;
        },
        // 根据面试id添加单个对话项
        addConversationItemByInterviewId(interviewId, conversationItem) {
            if (!this.interviewConversation[interviewId]) {
                this.interviewConversation[interviewId] = [];
            }
            this.interviewConversation[interviewId].push(conversationItem);
        },
        // 根据面试id清空对话列表
        clearConversationByInterviewId(interviewId) {
            if (this.interviewConversation[interviewId]) {
                this.interviewConversation[interviewId] = [];
            }
        },
        // 删除指定面试的对话缓存
        removeConversationByInterviewId(interviewId) {
            if (this.interviewConversation[interviewId]) {
                delete this.interviewConversation[interviewId];
            }
        },
        // 设置答题内容缓存
        setAnswerCacheByInterviewId(interviewId, data) {
            this.interviewAnswerCache[interviewId] = data;
        },
        // 获取答题内容缓存
        getAnswerCacheByInterviewId(interviewId) {
            return this.interviewAnswerCache[interviewId] || {};
        },
        // 清除答题内容缓存
        clearAnswerCacheByInterviewId(interviewId) {
            if (this.interviewAnswerCache[interviewId]) {
                delete this.interviewAnswerCache[interviewId];
            }
        },
        /**
         * interviewId: 面试id
         * question: 问题
         * answer: 快答内容（可选）
         * deepAnswer: 深度思考答案（可选）
         * screenshotAnswer: 截图回答内容（可选）
         */
        addAnswerRecordByInterviewId(interviewId, question, answer, deepAnswer, screenshotAnswer) {
            if (!this.interviewAnswerRecord[interviewId]) {
                this.interviewAnswerRecord[interviewId] = [];
            }
            // 查找是否已存在该问题
            const idx = this.interviewAnswerRecord[interviewId].findIndex(r => Object.keys(r)[0] === question);
            if (idx !== -1 && 1===2) {
                // 已有则合并
                const old = this.interviewAnswerRecord[interviewId][idx][question] || {};
                this.interviewAnswerRecord[interviewId][idx][question] = {
                    quick: answer !== undefined ? answer : old.quick,
                    deep: deepAnswer !== undefined ? deepAnswer : old.deep,
                    screenshot: screenshotAnswer !== undefined ? screenshotAnswer : old.screenshot
                };
            } else {
                this.interviewAnswerRecord[interviewId].push({
                    [question]: {
                        quick: answer !== undefined ? answer : '',
                        deep: deepAnswer !== undefined ? deepAnswer : '',
                        screenshot: screenshotAnswer !== undefined ? screenshotAnswer : ''
                    }
                });
            }
        },
        // 获取答题历史记录
        getAnswerRecordByInterviewId(interviewId) {
            return this.interviewAnswerRecord[interviewId] || [];
        },
        // 清除答题历史记录
        clearAnswerRecordByInterviewId(interviewId) {
            if (this.interviewAnswerRecord[interviewId]) {
                delete this.interviewAnswerRecord[interviewId];
            }
        },
        // 设置WebSocket累计计时
        setWebsocketTimeByInterviewId(interviewId, seconds) {
            this.websocketTime[interviewId] = seconds;
        },
        // 获取WebSocket累计计时
        getWebsocketTimeByInterviewId(interviewId) {
            return this.websocketTime[interviewId] || 0;
        },
    }
})